import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  CircularLoader,
  patientAccessTheme,
} from '@HomaHealth/ui-component-library';
import {
  Add,
  BasicTable,
  CardComponent,
  CustomiseTabs,
  EmptyAmico1,
  NoComplianceAssurances,
  SuggestedTaskIcon,
  Switch,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Columns } from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { observer } from 'mobx-react';
import React, { ChangeEvent, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import properties from '../../core-utils/properties';
import moment from 'moment';
import { useStores } from '../../stores';
import { useNavigate } from 'react-router-dom';
import { getTagProperties } from '../../core-utils/helper-utils/notificationHelpers';
import BasicModal from '../../_components/atoms/BasicModal';
import Snackbar from '../../_components/atoms/Snackbar';
import InsightsPopup from '../../_components/organisms/InsightsPopup';
import {
  formatRiskTableInsights,
  formatSuggestedTableInsightsExp,
  getReportName,
} from '../../core-utils/helper-utils/riskRegisterHelper';
import AcknowledgeRiskModal from '../../_components/organisms/AcknowledgeRiskModal';
import { handleDownloadReport } from '../../core-utils/helper-utils/contractReportHelper';
import {
  COMPENSATION_TRANSPARENCY_REPORT,
  GAG_CLAUSE_REPORT,
  INTER_CONTRACT_REPORT,
} from '../../core-utils/routes';
import ClaimsAnalysis from '../../_components/organisms/ExperienceTabs/ClaimsAnalysis';
import {
  formatPEPM,
  formatPMPM,
  formatTotalCost,
  PEPM,
  PMPM,
  TotalCost,
} from '../../core-utils/helper-utils/summaryReportHelper';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import usePlanDates, {
  getStartDateAndEndDate,
} from '../../core-utils/custom-hooks/PlanDates';
import RiskStratificationTab from '../../_components/organisms/ExperienceTabs/RiskStratificationTab';
import { TabItem } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/CustomiseTabs';
import RiskRegisterConstants from '../../core-utils/messages/RiskRegisterConstants';
import Loader from '../../_components/molecules/Loader';
import ComplianceReports from '../../_components/organisms/ExperienceTabs/ComplianceReports';
import NoNotify from '../../_components/molecules/NoNotify';
import TaskBoard from '../../_components/organisms/ExperienceTabs/TaskBoard';
import CostSummary from '../../_components/organisms/ExperienceTabs/CostSummary';
import SpendTrend from '../../_components/organisms/ExperienceTabs/SpendTrend';
import experienceConstants from '../../core-utils/messages/experienceConstants';
import OrganisationInfo from '../../_components/organisms/ExperienceTabs/OrganisationInfo';
import CareGaps from '../../_components/organisms/ExperienceTabs/CareGaps';
import RiskDetailsWindow from '../../_components/organisms/RiskDetailsWindow';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import InsightsTab from '../../_components/organisms/ExperienceTabs/InsightsTab';
import NotificationCard, {
  NotificationCardProps,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components/molecules/NotificationCard';
import HomeQuickLinks, {
  QuickLinkGroup,
  QuickLinkItem,
  UserQuickLinkOverride,
} from '../../_components/molecules/HomeQuickLinks';
import {
  extractOverridesFromTabs,
  generateTabs,
  mergeQuickLinks,
  normalizeQuickLinks,
} from '../../core-utils/helper-utils/homePageHelper';
import { messages as homePageMessages } from '../../core-utils/messages/homepagemessages';
// import { NoFeatureAccess } from '../../_components/molecules/NoFeatureAccess';
import TabsSection from '../../_components/organisms/TabsSelection';
import ProposalTab from '../../_components/organisms/ExperienceTabs/ProposalTab';
import DraftsTab from '../../_components/organisms/ExperienceTabs/DraftsTab';
import ChatModal from '../../_components/organisms/ChatModal';
import ChatIcon from '@mui/icons-material/Chat';
interface Document {
  document_name: string;
}
export interface NotificationCardProps2 {
  eg_nid: string;
  notification: string;
  tag: string;
  date: string;
  analysis_type: string[];
  tagIcons: React.JSX.Element;
  tagColor: string;
  cardTitleColor: string;
  handleOnclickInsights: () => void;
  insightsTitle: string;
  cardStyle?: React.CSSProperties;
  cardIcon?: React.JSX.Element;
}
export interface Evaluation {
  _id: string;
  contract_id?: string;
  plan_doc_id?: string;
  report_name: string;
  createdAt: string;
  updatedAt: string;
  description: string;
  status: string;
  compare_agreement_id: string;
}

export interface CardData {
  contractId: string;
  service_agreement_name: string;
  health_care_partner_name: string;
  effective_date: string;
  documents: Document[];
  evaluations: Evaluation[];
  status: string;
  compare_agreement_id: string;
  doc_type?: string;
  plan_names?: string[];
}

export interface TagProperties {
  tagColor: string;
  tagIcons: React.JSX.Element;
}

export interface CustomisedTabsState {
  analyses: {
    index: number;
    name: string;
    visibility: boolean;
    _id: string;
  }[];
  quickLinks: {
    quickLinkIndex: number;
    quickLinkName: string;
    quickLinkvisibility: boolean;
    _id: string;
  }[];
}
export interface ItemData {
  name: string;
  value: number;
  status?: 'low' | 'high' | '-';
  claimlevellookups_key: string;
  claimlevellookups_value: any;
}

const useStyles = makeStyles()({
  mainContainer: {
    padding: '16px 48px',
    display: 'flex',
    gap: '24px',
    overflow: 'hidden',
  },
  tabsContainer: {
    borderBottom: '1px solid #e5e7eb',
    marginBottom: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    zIndex: 0,
  },
  tab: {
    textTransform: 'none',
    minWidth: 120,
    fontWeight: 500,
    fontSize: '14px',
    zIndex: 10,
    color: '#374151',
    '&.Mui-selected': {
      color: '#4F46E5',
    },
  },
  tabLabelContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '95%',
    whiteSpace: 'nowrap',
    flexShrink: 0,
    zIndex: 0,
  },
  notificationMainContent: {
    height: '550px',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    marginTop: '10px',
  },
  notificationHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 16px 0px 12px',
  },
  notificationCardContainer: {
    borderBottom: '1px solid #E5E9F0',
    width: '100%',
    padding: '12px 16px 0px 16px',
  },
  notificationHeaderInner: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  itemContainer: {
    display: 'flex',
    gap: '30px',
  },
  noNotificationData: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
  },
  quickLink: {
    padding: '16px 48px',
  },
  chatIcon: {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    border: '2px solid #1976d2',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 9999,
    boxShadow: '0px 4px 12px rgba(0,0,0,0.2)',
    fontWeight: 700,
    fontSize: '20px',
    color: '#1976d2',
  },
  chatModal: {
    position: 'fixed',
    bottom: '90px',
    right: '24px',
    width: '550px',
    height: '600px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0px 6px 20px rgba(0,0,0,0.2)',
    zIndex: 9999,
    overflow: 'hidden',
  },
});

export interface SingleCardComponentProps {
  title: string;
  items: ItemData[];
  subTitle: string;
  backgroundColor?: string;
  borderColor?: string;
  rawCohortData: any;
  aggregatedColumn1Header?: string;
  aggregatedColumn1Value?: string;
  aggregatedColumn2Header?: string;
  aggregatedColumn2Value?: string;
  setIsKpiPopUp: React.Dispatch<React.SetStateAction<boolean>>;

  onArrowClick: (matchedSection: any) => void;
  handleNavigate: any;
}

const ExperiencePage: React.FC<{}> = observer(() => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const payload = useAPIPayload();
  const { getPlanDates } = usePlanDates();
  const messages = RiskRegisterConstants.MAIN_PAGE;
  const employerGroupStore = useStores().employerGroupStore;
  const { startDate, endDate } = getStartDateAndEndDate();
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
  const isClaims =
    employerGroupStore?.employerGroupResponseData?.is_claims_present;
  const loginPageStore = useStores().loginPageStore;
  const abortController = new AbortController();
  const costSections: any[] = [];
  const { snackbarState, openSnackbar, handleCloseSnackBar } = useSnackbar();
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isPlanDatesFetched,
    aggregationParameter,
    isIncurredDate,
    isPaidDate,
  } = quarterlyReportStore;
  const userAccess = loginPageStore.userResponse;

  const combinedScreens = Array.from(
    new Set([
      ...(userAccess.careNavigationScreens || []),
      ...(userAccess.complianceAssuranceScreens || []),
      ...(userAccess.riskManagementScreens || []),
    ]),
  );
  const isAdmin = userAccess.role.name;

  //Usestates
  //Loading
  const [mainLoader] = useState<any>(<Loader />);
  const [loading, setLoading] = useState(true);
  const [tabsLoading, setTabsLoading] = useState(true);
  const [isDocuments, setIsDocuments] = useState<boolean>();
  //Main Data
  const [organisationData, setOrganisation] = useState({
    employee_number: '',
    location: [],
    planType: '',
    renewalMonth: '',
    medicalNetwork: '',
    administrator: '',
    broker: '',
    stopLoss: '',
    pbm: '',
  });
  const [isEditOrg, setIsEditOrg] = useState<boolean>(false);
  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });
  const [pepm, setPEPM] = useState<PEPM>({
    pepm: '',
    pepmPercentage: '',
    increment: true,
  });
  const [pmpm, setPMPM] = useState<PMPM>({
    pmpm: '',
    pmpmPercentage: '',
    increment: true,
  });
  //Notifications
  const [newNotifyCount, setNewNotifyCount] = useState<number>(0);
  const [summary, setSummary] = useState({
    title: '',
    soruce: '',
    newdate: '',
  });
  const [isInsightsOpen, setIsInsightsOpen] = useState<boolean>(false);
  const [isSuggestedOpen, setIsSuggestedOpen] = useState<boolean>(false);
  const [notifications, setNotifications] = React.useState<
    NotificationCardProps[]
  >([]);
  const [riskData, setRiskData] = useState([]);
  const [suggestedData, setSuggestedData] = useState([]);
  //Tabs
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [customisedTabs, setCustomisedTabs] = useState<TabItem[]>([]);
  const [tempCustomisedTabs, setTempCustomisedTabs] = useState<TabItem[]>([]);
  // const [isNoAccess, setIsNoAccess] = useState<boolean>(false);

  //Popups
  const [isCustomiseTabOpen, setIsCustomiseTabOpen] = useState<boolean>(false);
  const [
    acknowledgeRiskModalOpen,
    setAcknowledgeRiskModalOpen,
  ] = useState<boolean>(false);
  const [selectedRisk, setSelectedRisk] = useState<any>(null);
  const [newRiskTableloading, setNewRiskTableLoading] = useState<boolean>(
    false,
  );
  const [newRiskTableData, setNewRiskTableData] = useState<any>([]);
  const [newSuggestedData, setNewSuggestedData] = useState<any>([]);
  const [newRiskTablePageNumber, setNewRiskTablePageNumber] = useState<number>(
    1,
  );

  const [
    activityDetailsWindowOpen,
    setActivityDetailsWindowOpen,
  ] = useState<boolean>(false);

  const [selectedActivity] = useState<any>(null);
  const [activeChip, setActiveChip] = useState<number[]>([]);
  const [userLinks, setUserLinks] = useState<QuickLinkGroup[]>([]);
  const [quickLinkModalItems, setQuickLinkModalItems] = useState<TabItem[]>([]);
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false);

  //Functions
  if (Number(totalCost?.totalCost.replace(/[^0-9.-]+/g, '')) > 0) {
    costSections.push([
      {
        label: 'Total Cost(Med + Rx):',
        value: `${totalCost?.totalCost}`,
        subvalue: `(${totalCost?.totalMedical || '$0M'} + ${
          totalCost?.totalRx || '$0M'
        })`,
      },
    ]);
  }
  if (Number(pepm?.pepm.replace(/[^0-9.-]+/g, '')) > 0) {
    costSections?.push([
      {
        label: 'PEPM',
        value: `${pepm?.pepm}`,
        subvalue: '',
      },
    ]);
  }
  if (Number(pmpm?.pmpm.replace(/[^0-9.-]+/g, '')) > 0) {
    costSections?.push([
      {
        label: 'PMPM',
        value: `${pmpm?.pmpm}`,
        subvalue: '',
      },
    ]);
  }

  const handleDownload = async () => {
    const reportName = getReportName(selectedRisk.source_report);
    let reportType = '';
    if (
      selectedRisk?.vendor_type?.includes(
        'Administrative Services Only (ASO) Provider',
      ) &&
      selectedRisk?.vendor_type?.includes('Stop-Loss Insurance Provider')
    ) {
      reportType = 'asa-stoploss';
    }
    handleDownloadReport(
      reportName,
      employerGroupStore.employerGroupResponseData.employer_group_name[0],
      selectedRisk?.contract_id?._id,
      openSnackbar,
      employerGroupStore.employerGroupResponseData.eg_nid[0],
      selectedRisk?.compare_agreement_id?._id,
      reportType,
    );
  };

  const handleUpdateRisk = async (data: any) => {
    const formData = new FormData();
    for (const key in data) {
      if (key === 'files') {
        continue;
      } // handle files separately below
      const value = data[key];
      if (Array.isArray(value)) {
        if (value.length && typeof value[0] === 'object') {
          // For arrays of objects like `activity`
          formData.append(key, JSON.stringify(value));
        } else {
          // For arrays of strings like `impact`, `owner`
          value.forEach((item: any, index: number) => {
            formData.append(`${key}[${index}]`, item);
          });
        }
      } else if (typeof value === 'object' && value !== null) {
        // In case any single object sneaks in
        formData.append(key, JSON.stringify(value));
      } else if (value !== '') {
        formData.append(key, value); // Only append non-empty values
      }
    }
    formData.append(
      'eg_nid',
      employerGroupStore.employerGroupResponseData.eg_nid[0],
    );
    formData.append(
      'employer',
      employerGroupStore.employerGroupResponseData.employer_group_name[0],
    );
    if (data.files && Array.isArray(data.files)) {
      data.files.forEach((file: File) => {
        formData.append('files', file);
      });
    }
    await axios.post(
      properties.aiqBaseUrl +
        properties.riskRegisterBaseUrl +
        properties.updateRisk,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    openSnackbar('Insights has been acknowledge', 'success', 6000);
    setIsInsightsOpen(false);
  };

  const handleNavigate = (
    contract: any,
    report: any,
    compare_agreement_id: any,
    openSnackbar: any,
  ) => {
    let path = '';
    switch (report) {
      case 'Gag Clause Compliance Check':
        path = GAG_CLAUSE_REPORT;
        break;
      case 'Provision Favorability Check':
        handleDownloadReport(
          'provisionMatrixReport',
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
          contract._id,
          openSnackbar,
        );
        return;
      case 'Compensation Transparency Check':
        path = COMPENSATION_TRANSPARENCY_REPORT;
        break;
      case 'Inter-Contract Compliance Stop Loss and ASA':
      case 'Gap Analysis Check Plan Document and ASA':
      case 'Gap Analysis Check Plan Document and PBM':
        path = INTER_CONTRACT_REPORT;
        break;
      case 'Commercial Evaluation':
        handleDownloadReport(
          'feeEvaluationReport',
          employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
          contract._id,
          openSnackbar,
        );
        return;
      default:
        return;
    }
    navigate(path);
  };

  const groupedData = [
    [
      {
        label: 'Employees',
        value: organisationData?.employee_number
          ? `${organisationData.employee_number}`
          : '-',
      },
      {
        label: 'Location',
        value:
          organisationData?.location?.length > 0
            ? organisationData.location.join(', ')
            : '-',
      },
      {
        label: 'Plan Type',
        value: organisationData?.planType || '-',
      },
      {
        label: 'Renewal Month',
        value: organisationData?.renewalMonth || '-',
      },
    ],
    [
      {
        label: 'Medical Network',
        value: organisationData?.medicalNetwork || '-',
      },
      {
        label: 'PBM',
        value: organisationData?.pbm || '-',
      },
    ],
    [
      {
        label: 'Administrator',
        value: organisationData?.administrator || '-',
      },
      {
        label: 'Broker',
        value: organisationData?.broker || '-',
      },
      {
        label: 'Stop Loss',
        value: organisationData?.stopLoss || '-',
      },
    ],
  ];

  // const handleNoAccessClick = () => {
  //   setIsNoAccess(true);
  // };

  // Stratergy Insights constants
  const handleRiskClick = (risk: any) => {
    setSelectedRisk(risk);
  };

  const handleAction = (risk: any) => {
    setSelectedRisk(risk);
    setIsInsightsOpen(false);
    setAcknowledgeRiskModalOpen(true);
  };

  const handleSuggestedAction = (risk: any) => {
    navigate('/task-board', {
      state: {
        riskAsTask: risk,
      },
    });
  };

  const handleAcknowledgeAction = async (risk: any) => {
    const data = {
      risk_id: risk?._id,
      status: 'Accepted',
    };
    await handleUpdateRisk(data);
  };

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setSelectedTabIndex(newValue);
  };

  const handleUpdatedAnalyses = () => {
    const transformedAnalyses = tempCustomisedTabs?.map((item, idx) => ({
      index: idx,
      name: item?.label,
      visibility: item?.visible,
      _id: item.id,
    }));
    updateCustomiseAnalyses({
      egNid: egNid,
      analyses: transformedAnalyses,
    });
  };

  const handleUpdateQuickLinks = async () => {
    const overrides = extractOverridesFromTabs(quickLinkModalItems);
    const normalized = normalizeQuickLinks(
      homePageMessages.QUICK_LINKS,
      homePageMessages.HIDDEN_QUICK_LINKS,
      combinedScreens,
      isAdmin,
    );
    const merged = mergeQuickLinks(normalized, overrides);

    setUserLinks(merged);
    setQuickLinkModalItems(generateTabs(merged));

    await updateQuickLinks(egNid, overrides).then(() => {
      openSnackbar('Quick Links updated Successfully', 'success', 3000);
    });
  };

  const handleItemAction = (id: string, actionType: string, value?: any) => {
    if (actionType === 'toggle-visibility') {
      if (value === false) {
        const currentVisible = tempCustomisedTabs.filter((t) => t.visible)
          .length;
        if (currentVisible === 1) {
          openSnackbar(`At least one tab must remain visible.`, 'info', 3000);
          return;
        }
      }
      setTempCustomisedTabs((prevTabs) =>
        prevTabs?.map((tab) => {
          if (tab.id === id) {
            return { ...tab, visible: value };
          }
          return tab;
        }),
      );
    }
  };

  const handleCloseCustomiseTab = () => {
    setIsCustomiseTabOpen(false);
  };

  const handleCustomiseTabOpen = () => {
    setIsCustomiseTabOpen(true);
  };

  const handleCardClick = (item: QuickLinkItem) => {
    if (isAdmin !== 'super_admin') {
      if (
        !combinedScreens.includes(item.SCREEN_NAME) ||
        item.SCREEN_NAME === ''
      ) {
        openSnackbar(
          `Access to ${item.TITLE} is restricted. Please contact support.`,
          'error',
          5000,
        );
        return;
      }
    }

    navigate(item.LINK);
  };

  const handleSend = async ({
    message,

    files,
  }: {
    message: string;
    files: File[];
  }) => {
    // console.log(message);
    // console.log(files);

    // here you will call API later
    return {
      text: 'hello',
    };
  };

  const getFilteredTabs = () => {
    const claimsTabs = [
      'Claims Analysis',
      'Risk Stratification',
      'Spend Trend',
      'Care Gaps',
    ];
    const docsTabs = ['Documents'];
    const defaultTabs = [
      'Task Board',
      'Strategy & Insights Board',
      'Drafts',
      'Proposals',
    ];

    let allowedTabs: string[] = [...defaultTabs];

    if (isClaims) {
      allowedTabs = [...allowedTabs, ...claimsTabs];
    }
    if (isDocuments) {
      allowedTabs = [...allowedTabs, ...docsTabs];
    }

    const filteredTabs = experienceConstants?.DEFAULT_TABS.filter((tab) =>
      allowedTabs.includes(tab.name),
    )
      .map((tab) => ({
        ...tab,
        visible: tab.visibility,
        label: tab.name,
      }))
      ?.sort((a, b) => (a.visible === b.visible ? 0 : a.visible ? -1 : 1));

    return filteredTabs.sort((a, b) =>
      a.index === b.index ? 0 : a.index - b.index,
    );
  };

  const isSameDate = (d1?: string | Date, d2?: string | Date) => {
    if (!d1 || !d2) {
      return false;
    }
    return (
      new Date(d1).toISOString().slice(0, 10) ===
      new Date(d2).toISOString().slice(0, 10)
    );
  };

  //Axios Calls
  const getOrganizationInfo = async () => {
    try {
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.dataCatalogueBaseURL +
          properties.getOrganizationInfo,
        {
          eg_nid: egNid,
        },
      );
      const rawData = response.data?.data;
      const formatted = {
        employee_number: rawData?.general_info?.number_of_employees,
        location: rawData?.employer_plan?.states_of_employees,
        pbm: rawData?.key_vendors_partners?.pharmacy_benefit_manager?.name,
        planType: rawData?.employer_plan?.plan_funding_type,
        renewalMonth: rawData?.employer_plan?.renewal_month,
        medicalNetwork: rawData?.key_vendors_partners?.network_carrier?.name,
        administrator:
          rawData?.key_vendors_partners?.tpa_claims_administrator?.name,
        broker: rawData?.key_vendors_partners?.broker_consultant?.name,
        stopLoss: rawData?.key_vendors_partners?.stop_loss_insurer?.name,
      };
      setIsDocuments(rawData?.employer_plan?.number_of_documents > 0);
      setOrganisation(formatted);
    } catch (error) {
      openSnackbar('Error Fetching Organization Information', 'error', 3000);
    }
  };

  const getTotalEligible = async (): Promise<any | null> => {
    try {
      const response = await axios.post(
        properties.aiqBaseUrl + properties.summaryBaseUrl,
        {
          ...payload,
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
          claim_id_list: cohortDetailsStore.claimIdList,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
        },
        { signal: abortController.signal },
      );
      const data = response?.data?.data;
      setTotalCost(formatTotalCost(data, 2));
      return data || null;
    } catch (error: any) {
      return null;
    }
  };

  const getPMPMAndPepm = async (): Promise<any | null> => {
    try {
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.summaryBaseUrl +
          properties.pmpmAndPepm,
        {
          startDate:
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
          endDate:
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          claim_id_list: cohortDetailsStore.claimIdList,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        { signal: abortController.signal },
      );

      setPMPM(formatPMPM(response?.data?.data?.pmpm));
      setPEPM(formatPEPM(response?.data?.data?.pepm));
    } catch (error: any) {
      openSnackbar(error?.message || 'Something went wrong', 'error', 6000);
    }
  };

  const getAllInsights = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.insightsNotification,
        {
          eg_nid: egNid,
        },
      )
      .then(async (response) => {
        if (response.status === 200) {
          const rawData = response.data.data;
          // Count unviewed notifications
          const unviewedCount = rawData.filter(
            (item: any) => item.isView === false,
          ).length;

          // Update state with new notification count
          setNewNotifyCount(unviewedCount);
          if (unviewedCount > 0) {
            await axios
              .put(
                properties.aiqBaseUrl +
                  properties.contractBaseUrl +
                  properties.updateNotificationView,
                { eg_nid: egNid },
              )
              .then(() => {})
              .catch((error) => error);
          }
          const cards = rawData.map(
            (item: any): NotificationCardProps => {
              const {
                tagColor,
                tagIcons,
                insightsTitle,
                cardStyle,
                cardIcon,
              } = getTagProperties(item.tag);
              const isPlural = item.analysis_type?.length > 1;

              const dynamicTitle = insightsTitle.includes('Insight')
                ? isPlural
                  ? 'Insights discovered'
                  : 'Insight discovered'
                : insightsTitle.includes('Task')
                ? isPlural
                  ? 'Suggested Tasks'
                  : 'Suggested Task'
                : insightsTitle;
              return {
                eg_nid: [item.eg_nid],
                notification: item.notification,
                tag: item.tag,
                date: moment.utc(item?.createdAt).format('MMMM D, YYYY'),

                analysis_type: item.analysis_type.map(
                  (a: any) => a.title ?? a.name,
                ),
                tagIcons,
                tagColor,
                insightsTitle: dynamicTitle,

                cardStyle,
                cardIcon,
                cardTitleColor: tagColor, // Use the same color as tagColor or set a default
                handleOnclickInsights: () => {
                  const tagLower = item.tag?.toLowerCase();
                  if (tagLower === 'operations') {
                    setSummary((prev) => ({
                      ...prev,
                      title: item?.notification,
                      newDate: moment
                        .utc(item?.createdAt)
                        .format('MMMM D, YYYY'),
                      source: item?.tag,
                    }));
                    setIsSuggestedOpen(true);
                    setSuggestedData(item?.analysis_type);
                  } else {
                    setSummary((prev) => ({
                      ...prev,
                      title: item.notification,
                      newDate: moment(item.createdAt).format('D MMM YYYY'),
                      source: item.tag,
                    }));
                    setIsInsightsOpen(true);
                    setRiskData(item.analysis_type);
                  }
                },
              };
            },
          );
          setNotifications(cards);
        }
      })
      .catch((error) => error);
  };

  const getCustomiseAnalyses = async () => {
    try {
      setTabsLoading(true);
      const response = await axios.post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getCustomiseTabs,
        {
          eg_nid: egNid,
        },
      );
      const data = response?.data?.data;
      if (data?.isSaved) {
        const analysisTabs = data?.analyses?.map((item: any) => ({
          id: item?._id || item?.name.toLowerCase().replace(/\s+/g, '_'),
          label: item?.name,
          visible: item?.visibility,
          index: item?.index ?? 0,
        }));

        const existingLabels = analysisTabs.map((tab: any) => tab.label);

        // Add missing tabs from DEFAULT_TABS
        experienceConstants?.DEFAULT_TABS.forEach((tab, idx) => {
          if (!existingLabels.includes(tab.name)) {
            analysisTabs.push({
              id: tab.id || tab.name.toLowerCase().replace(/\s+/g, '_'),
              label: tab.name,
              visible: tab.visibility,
              index: tab.index ?? analysisTabs.length + idx,
            });
          }
        });

        analysisTabs.sort((a: any, b: any) =>
          a.visible === b.visible ? 0 : a.visible ? -1 : 1,
        );

        setCustomisedTabs(analysisTabs);
        setTempCustomisedTabs(analysisTabs);
      } else {
        const tabs = getFilteredTabs();

        setCustomisedTabs(tabs);
        setTempCustomisedTabs(tabs);
      }
      const normalized = normalizeQuickLinks(
        homePageMessages.QUICK_LINKS,
        homePageMessages.HIDDEN_QUICK_LINKS,
        combinedScreens,
        isAdmin,
      );

      const merged = mergeQuickLinks(normalized, data?.quickLinks ?? []);
      setUserLinks(merged);
      setQuickLinkModalItems(generateTabs(merged));
    } catch (error: any) {
      setTabsLoading(false);
      openSnackbar('Failed to load tabs', 'error', 6000);
    } finally {
      setTabsLoading(false);
    }
  };

  const updateCustomiseAnalyses = async ({
    egNid,
    analyses,
  }: {
    egNid: string;
    analyses: any[];
  }) => {
    try {
      const response = await axios.post(
        `${properties.aiqBaseUrl}${properties.contractBaseUrl}${properties.updateCustomiseTabs}`,
        {
          eg_nid: egNid,
          analyses,
        },
      );
      openSnackbar('Analysis tab updated successfully', 'success', 3000);
      await getCustomiseAnalyses();
      return response.data;
    } catch (error: any) {
      openSnackbar(error?.message || 'Something went wrong', 'error', 6000);
    } finally {
      setIsCustomiseTabOpen(false);
    }
  };

  const fetchInitialData = async () => {
    try {
      const results = await Promise.allSettled([
        getTotalEligible(),
        getPMPMAndPepm(),
      ]);
      results?.forEach((res) => {
        if (res.status === 'rejected') {
          openSnackbar(
            res.reason?.message || 'Something went wrong',
            'error',
            6000,
          );
        }
      });
    } catch (err) {
      openSnackbar('Unexpected error occurred.', 'error', 6000);
    } finally {
    }
  };

  const updateQuickLinks = async (
    egNid: string,
    overrides: UserQuickLinkOverride[],
  ) => {
    return await axios.post(
      properties.aiqBaseUrl +
        properties.contractBaseUrl +
        properties.updateQuickLinks,
      { egNid, overrides },
    );
  };

  const initialAPIs = async () => {
    try {
      setLoading(true);

      const promises = [getOrganizationInfo(), getAllInsights()];
      if (!isPlanDatesFetched) {
        promises.push(getPlanDates());
      }
      if (
        (isPaidDate &&
          (!isSameDate(startDate, paidStartDate) ||
            !isSameDate(endDate, paidEndDate))) ||
        (isIncurredDate &&
          (!isSameDate(startDate, incurredStartDate) ||
            !isSameDate(endDate, incurredEndDate)))
      ) {
        promises.push(getPlanDates());
      } else {
        return;
      }
      await Promise.all(promises);
    } catch (error: any) {
      openSnackbar(error.response?.data?.error, 'error', 3000);
    } finally {
      setLoading(false);
    }
  };

  // UseEffects
  useEffect(() => {
    if (!egNid) {
      return;
    }
    initialAPIs();
    return () => {
      abortController.abort();
    };
  }, [egNid]);

  useEffect(() => {
    if (isDocuments !== undefined) {
      getCustomiseAnalyses();
    }
  }, [isDocuments]);

  useEffect(() => {
    paidStartDate !== '' &&
      paidEndDate !== '' &&
      incurredEndDate !== '' &&
      incurredStartDate !== '' &&
      fetchInitialData();
    return () => {
      abortController.abort();
    };
  }, [
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
  ]);

  const sortedTabs = useMemo(() => {
    return customisedTabs
      ?.filter((tab) => tab?.visible)
      ?.sort((a: any, b: any) => a.index - b.index);
  }, [customisedTabs]);

  useEffect(() => {
    if (riskData?.length > 0) {
      setNewRiskTableLoading(true);
      Promise.resolve()
        .then(() => {
          const formattedNewRisks = formatRiskTableInsights(
            riskData,
            handleRiskClick,
            handleAction,
            handleAcknowledgeAction,
          );
          setNewRiskTableData(formattedNewRisks);
        })
        .finally(() => {
          setNewRiskTableLoading(false);
        });
    }
  }, [riskData]);

  useEffect(() => {
    if (suggestedData?.length > 0) {
      setNewRiskTableLoading(true);
      Promise.resolve()
        .then(() => {
          const formattedNewRisks = formatSuggestedTableInsightsExp(
            suggestedData,
            // handleRiskClick,
            handleSuggestedAction,
          );
          setNewSuggestedData(formattedNewRisks);
        })
        .finally(() => {
          setNewRiskTableLoading(false);
        });
    }
  }, [suggestedData]);

  // Reusable Components
  const renderVisibilityControl = (tab: any, onAction: any) => (
    <Switch
      checked={tab.visible}
      color="primary"
      handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onAction('toggle-visibility', e.target.checked)
      }
    />
  );

  const renderTabContent = (tabLabel: string) => {
    switch (tabLabel) {
      case 'Documents':
        return (
          <ComplianceReports
            egNid={egNid}
            incurredStartDate={incurredStartDate}
            incurredEndDate={incurredEndDate}
            paidStartDate={paidStartDate}
            paidEndDate={paidEndDate}
            isPlanDatesFetched={isPlanDatesFetched}
            aggregationParameter={aggregationParameter}
          />
        );
      case 'Claims Analysis':
        return (
          <ClaimsAnalysis
            egnid={egNid}
            incurredStartDate={incurredStartDate}
            incurredEndDate={incurredEndDate}
            paidStartDate={paidStartDate}
            paidEndDate={paidEndDate}
            isPlanDatesFetched={isPlanDatesFetched}
            aggregationParameter={aggregationParameter}
          />
        );
      case 'Risk Stratification':
        return (
          <RiskStratificationTab
            incurredStartDate={incurredStartDate}
            incurredEndDate={incurredEndDate}
            paidStartDate={paidStartDate}
            paidEndDate={paidEndDate}
            isPlanDatesFetched={isPlanDatesFetched}
            aggregationParameter={aggregationParameter}
          />
        );
      case 'Spend Trend':
        return (
          <SpendTrend
            incurredStartDate={incurredStartDate}
            incurredEndDate={incurredEndDate}
            paidStartDate={paidStartDate}
            paidEndDate={paidEndDate}
            isPlanDatesFetched={isPlanDatesFetched}
            aggregationParameter={aggregationParameter}
            isIncurredDate={isIncurredDate}
            isPaidDate={isPaidDate}
            totalCost={totalCost.totalCost}
          />
        );
      case 'Task Board':
        return (
          <TaskBoard
            renewalMonth={organisationData?.renewalMonth}
            incurredStartDate={incurredStartDate}
            incurredEndDate={incurredEndDate}
            paidStartDate={paidStartDate}
            paidEndDate={paidEndDate}
            isPlanDatesFetched={isPlanDatesFetched}
            aggregationParameter={aggregationParameter}
            setIsEditOrg={setIsEditOrg}
          />
        );
      case 'Care Gaps':
        return (
          <CareGaps
            incurredStartDate={incurredStartDate}
            incurredEndDate={incurredEndDate}
            paidStartDate={paidStartDate}
            paidEndDate={paidEndDate}
            isPlanDatesFetched={isPlanDatesFetched}
            aggregationParameter={aggregationParameter}
          />
        );
      case 'Strategy & Insights Board':
        return (
          <InsightsTab
            renewalMonth={organisationData?.renewalMonth || 'January'}
            incurredStartDate={incurredStartDate}
            incurredEndDate={incurredEndDate}
            paidStartDate={paidStartDate}
            paidEndDate={paidEndDate}
            isPlanDatesFetched={isPlanDatesFetched}
            aggregationParameter={aggregationParameter}
          />
        );
      case 'Drafts':
        return (
          <DraftsTab
            egNid={egNid}
            incurredStartDate={incurredStartDate}
            incurredEndDate={incurredEndDate}
            paidStartDate={paidStartDate}
            paidEndDate={paidEndDate}
            isPlanDatesFetched={isPlanDatesFetched}
            aggregationParameter={aggregationParameter}
          />
        );
      case 'Proposals':
        return (
          <ProposalTab
            egNid={egNid}
            incurredStartDate={incurredStartDate}
            incurredEndDate={incurredEndDate}
            paidStartDate={paidStartDate}
            paidEndDate={paidEndDate}
            isPlanDatesFetched={isPlanDatesFetched}
            aggregationParameter={aggregationParameter}
          />
        );
      default:
        return null;
    }
  };

  return loading ? (
    mainLoader
  ) : (
    <Grid>
      <OrganisationInfo
        groupedData={groupedData}
        setIsEditOrg={setIsEditOrg}
        organisationData={organisationData}
        isEditOrg={isEditOrg}
        getOrganizationInfo={getOrganizationInfo}
        getAllInsights={getAllInsights}
      />
      {isClaims !== false && (
        <CostSummary
          costSections={costSections}
          incurredStartDate={incurredStartDate}
          incurredEndDate={incurredEndDate}
          paidStartDate={paidStartDate}
          paidEndDate={paidEndDate}
        />
      )}
      <Grid className={classes.mainContainer}>
        <TabsSection
          sortedTabs={sortedTabs}
          selectedTabIndex={selectedTabIndex}
          handleTabChange={handleTabChange}
          handleCustomiseTabOpen={handleCustomiseTabOpen}
          renderTabContent={renderTabContent}
          tabsLoading={tabsLoading}
          mainLoader={mainLoader}
          combinedScreens={combinedScreens}
          userAccess={userAccess}
        />
        {/* Notification Section */}
        <CardComponent
          mainGridStyles={{
            width: '30%',
            padding: '0px',
            height: '614px',
          }}
          title=""
          body={
            <Grid
              container
              sx={{
                flexDirection: 'column',
              }}
            >
              <Grid className={classes.notificationHeader}>
                <Grid className={classes.notificationHeaderInner}>
                  <Typography
                    textColor={patientAccessTheme?.palette?.text?.highemphasis}
                    fontType="semiBold"
                    fontSize="14px"
                  >
                    Notifications
                  </Typography>
                  <Grid
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '16px',
                      height: '16px',
                      backgroundColor: '#D6545E',
                      // padding: '4px',
                      borderRadius: '22px',
                      whiteSpace: 'nowrap',
                      // gap: '10px',
                      gap: '0px', // changed from 10px to 0
                      padding: '0px',
                    }}
                  >
                    <Typography
                      fontSize="10px"
                      fontType="semiBold"
                      textColor="#FFFFFF"
                      styleProps={{
                        marginTop: 'auto',
                      }}
                    >
                      {newNotifyCount}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid className={classes.notificationMainContent}>
                {notifications?.length > 0 ? (
                  notifications?.map((card, index) => (
                    <Grid
                      key={index}
                      className={classes.notificationCardContainer}
                    >
                      <NotificationCard {...card} />
                    </Grid>
                  ))
                ) : (
                  <Grid className={classes.noNotificationData}>
                    <NoNotify
                      label={'No Insights & Notifications Available !'}
                    />
                  </Grid>
                )}
              </Grid>
            </Grid>
          }
        />
      </Grid>
      <Grid className={classes.quickLink}>
        <HomeQuickLinks
          activeChips={activeChip}
          setActiveChips={setActiveChip}
          handleCardClick={handleCardClick}
          handleUpdateQuickLinks={handleUpdateQuickLinks}
          userLinks={userLinks}
          tabs={quickLinkModalItems}
          setTabs={setQuickLinkModalItems}
          // onCustomizeClick={handleQuickLinkTabOpen}
          // handleAccessClick={handleNoAccessClick}
        />
      </Grid>

      <BasicModal
        open={isInsightsOpen}
        width="1000px"
        height="auto"
        handleClose={() => {
          setIsInsightsOpen(false);
        }}
        title={riskData?.length > 1 ? 'Insights' : 'Insight'}
        isSaveButton={true}
        saveBtnText="Go to Strategy and Insights Board"
        saveBtnAction={() => {
          navigate('/risk-register');
        }}
        isScrollable={true}
        isCloseBtn={true}
      >
        <Grid>
          <InsightsPopup
            data={summary}
            insightsDiscovered={riskData?.length}
            children={
              <Grid>
                {newRiskTableloading ? (
                  <CircularLoader />
                ) : newRiskTableData ? (
                  <BasicTable
                    columns={
                      experienceConstants.INSIGHTS
                        .NEW_RISK_TABLE_COLUMNS as Columns[]
                    }
                    rowsData={newRiskTableData}
                    hideColumnIndex={0}
                    showPagination={true}
                    pageNumber={newRiskTablePageNumber}
                    handlePagination={(
                      event: ChangeEvent<unknown>,
                      page: number,
                    ) => {
                      setNewRiskTablePageNumber(page);
                    }}
                  />
                ) : (
                  <NoComplianceAssurances
                    isImageOnTop={true}
                    title={messages.NO_NEW_RISK}
                    subTitle={messages.NO_NEW_RISK_SUB}
                    image={<EmptyAmico1 />}
                    buttonLabel={messages.ADD_NEW_RISK}
                    handleOnclick={() => {
                      setIsSuggestedOpen(true);
                    }}
                    startIcon={<Add />}
                    rootStyles={{
                      border: '0px',
                      background: '',
                      padding: '20px',
                      height: '350px',
                    }}
                    titleFont="18px"
                    subTitleFont="14px"
                    subTitleMargin="0px"
                  />
                )}
              </Grid>
            }
          />
        </Grid>
      </BasicModal>
      {/* Suggested notification popup */}
      <BasicModal
        open={isSuggestedOpen}
        width="1000px"
        height="auto"
        handleClose={() => {
          setIsSuggestedOpen(false);
        }}
        title={
          newSuggestedData?.length > 1 ? 'Suggested Tasks' : 'Suggested Task'
        }
        isSaveButton={false}
        isScrollable={true}
        isCloseBtn={true}
      >
        <Grid>
          <InsightsPopup
            data={summary}
            insightsDiscovered={newSuggestedData?.length}
            insightsTitle={'Suggested Task'}
            insightIcon={<SuggestedTaskIcon width={'20px'} height={'20px'} />}
            children={
              <Grid>
                <BasicTable
                  columns={
                    experienceConstants.INSIGHTS
                      .SUGGESTED_TABLE_COLUMNS as Columns[]
                  }
                  rowsData={newSuggestedData}
                  hideColumnIndex={0}
                  showPagination={true}
                  pageNumber={newRiskTablePageNumber}
                  handlePagination={(
                    event: ChangeEvent<unknown>,
                    page: number,
                  ) => {
                    setNewRiskTablePageNumber(page);
                  }}
                />
              </Grid>
            }
          />
        </Grid>
      </BasicModal>

      {acknowledgeRiskModalOpen && (
        <AcknowledgeRiskModal
          open={acknowledgeRiskModalOpen}
          setOpen={setAcknowledgeRiskModalOpen}
          handleOpenSnackBar={openSnackbar}
          handleSubmit={handleUpdateRisk}
          risk={selectedRisk}
          handleDownload={handleDownload}
          handleNavigate={handleNavigate}
          eg_nid={egNid}
        />
      )}

      {activityDetailsWindowOpen && (
        <RiskDetailsWindow
          risk={selectedRisk}
          activity={selectedActivity}
          setDetailsWindowOpen={setActivityDetailsWindowOpen}
          handleSave={handleUpdateRisk}
          handleOpenSnackBar={openSnackbar}
          isActivityWindow={true}
          // handleBack={handleBack}
        />
      )}

      {/* custom tab popup */}
      <BasicModal
        open={isCustomiseTabOpen}
        max_height="530px"
        handleClose={() => {
          setTempCustomisedTabs([...customisedTabs]); // Deep copy to reset
          handleCloseCustomiseTab();
        }}
        title={'Customise Tabs'}
        isSaveButton={true}
        saveBtnText="Save Configuration"
        saveBtnAction={() => {
          handleUpdatedAnalyses();
          setSelectedTabIndex(0); // Reset selection to first tab
        }}
        isScrollable={true}
        isCloseBtn={true}
        width="auto"
      >
        <CustomiseTabs
          open={true}
          title1="Arrange and select tabs"
          title2="Visibility"
          tabs={tempCustomisedTabs}
          renderItemAction={renderVisibilityControl}
          onItemAction={handleItemAction}
          width="100%"
          setTabs={setTempCustomisedTabs}
        />
      </BasicModal>

      {/* <BasicModal
        open={isNoAccess}
        children={<NoFeatureAccess />}
        title={'Feature Access'}
        isSaveButton={false}
        handleClose={() => {
          setIsNoAccess(false);
        }}
      /> */}

      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />

      {/* Floating Chat Button */}
      {isAdmin === 'super_admin' && (
        <Box
          onClick={() => setIsChatOpen((prev) => !prev)}
          className={classes.chatIcon}
        >
          <ChatIcon style={{ color: '#1976d2', fontSize: '22px' }} />
        </Box>
      )}
      {isChatOpen && (
        <Box className={classes.chatModal}>
          <ChatModal
            title="Homa 2.O"
            placeholder="Ask anything..."
            acceptedFileTypes={['application/pdf', 'image/png']}
            onSend={handleSend}
          />
        </Box>
      )}
    </Grid>
  );
});

export default ExperiencePage;
